import(/* webpackMode: "eager" */ "/home/gs/apps/client-app/src/app/error.tsx");
